var _rect, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardActiveDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.2146,
    y: 5.42871,
    width: 9.50058,
    height: 9.50058,
    rx: 3.39306,
    fill: "#0088CC",
    stroke: "#0088CC",
    strokeWidth: 2.03584
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5443_3676",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6075 17.9832C20.1714 17.9832 18.1965 19.958 18.1965 22.3941V25.1086C18.1965 27.5447 20.1714 29.5196 22.6075 29.5196H25.322C27.7581 29.5196 29.7329 27.5447 29.7329 25.1086V22.3941C29.7329 19.958 27.7581 17.9832 25.322 17.9832H22.6075Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6075 17.9832C20.1714 17.9832 18.1965 19.958 18.1965 22.3941V25.1086C18.1965 27.5447 20.1714 29.5196 22.6075 29.5196H25.322C27.7581 29.5196 29.7329 27.5447 29.7329 25.1086V22.3941C29.7329 19.958 27.7581 17.9832 25.322 17.9832H22.6075Z",
    fill: "#CAD6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5358 22.3941C18.5358 20.1454 20.3588 18.3225 22.6075 18.3225V17.6438C19.984 17.6438 17.8572 19.7706 17.8572 22.3941H18.5358ZM18.5358 25.1086V22.3941H17.8572V25.1086H18.5358ZM22.6075 29.1803C20.3588 29.1803 18.5358 27.3573 18.5358 25.1086H17.8572C17.8572 27.7321 19.984 29.8589 22.6075 29.8589V29.1803ZM25.322 29.1803H22.6075V29.8589H25.322V29.1803ZM29.3936 25.1086C29.3936 27.3573 27.5707 29.1803 25.322 29.1803V29.8589C27.9455 29.8589 30.0723 27.7321 30.0723 25.1086H29.3936ZM29.3936 22.3941V25.1086H30.0723V22.3941H29.3936ZM25.322 18.3225C27.5707 18.3225 29.3936 20.1454 29.3936 22.3941H30.0723C30.0723 19.7706 27.9455 17.6438 25.322 17.6438V18.3225ZM22.6075 18.3225H25.322V17.6438H22.6075V18.3225Z",
    fill: "url(#paint0_linear_5443_3676)",
    fillOpacity: 0.7,
    mask: "url(#path-2-inside-1_5443_3676)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_5443_3676",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03549 17.9832C6.59938 17.9832 4.62451 19.958 4.62451 22.3941V25.1086C4.62451 27.5447 6.59938 29.5196 9.03549 29.5196H11.7499C14.1861 29.5196 16.1609 27.5447 16.1609 25.1086V22.3941C16.1609 19.958 14.1861 17.9832 11.7499 17.9832H9.03549Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03549 17.9832C6.59938 17.9832 4.62451 19.958 4.62451 22.3941V25.1086C4.62451 27.5447 6.59938 29.5196 9.03549 29.5196H11.7499C14.1861 29.5196 16.1609 27.5447 16.1609 25.1086V22.3941C16.1609 19.958 14.1861 17.9832 11.7499 17.9832H9.03549Z",
    fill: "#CAD6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96382 22.3941C4.96382 20.1454 6.78677 18.3225 9.03549 18.3225V17.6438C6.41198 17.6438 4.28521 19.7706 4.28521 22.3941H4.96382ZM4.96382 25.1086V22.3941H4.28521V25.1086H4.96382ZM9.03549 29.1803C6.78677 29.1803 4.96382 27.3573 4.96382 25.1086H4.28521C4.28521 27.7321 6.41198 29.8589 9.03549 29.8589V29.1803ZM11.7499 29.1803H9.03549V29.8589H11.7499V29.1803ZM15.8216 25.1086C15.8216 27.3573 13.9987 29.1803 11.7499 29.1803V29.8589C14.3735 29.8589 16.5002 27.7321 16.5002 25.1086H15.8216ZM15.8216 22.3941V25.1086H16.5002V22.3941H15.8216ZM11.7499 18.3225C13.9987 18.3225 15.8216 20.1454 15.8216 22.3941H16.5002C16.5002 19.7706 14.3735 17.6438 11.7499 17.6438V18.3225ZM9.03549 18.3225H11.7499V17.6438H9.03549V18.3225Z",
    fill: "url(#paint1_linear_5443_3676)",
    fillOpacity: 0.7,
    mask: "url(#path-4-inside-2_5443_3676)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_5443_3676",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03549 4.41089C6.59938 4.41089 4.62451 6.38575 4.62451 8.82187V11.5363C4.62451 13.9724 6.59938 15.9473 9.03549 15.9473H11.7499C14.1861 15.9473 16.1609 13.9724 16.1609 11.5363V8.82187C16.1609 6.38575 14.1861 4.41089 11.7499 4.41089H9.03549Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03549 4.41089C6.59938 4.41089 4.62451 6.38575 4.62451 8.82187V11.5363C4.62451 13.9724 6.59938 15.9473 9.03549 15.9473H11.7499C14.1861 15.9473 16.1609 13.9724 16.1609 11.5363V8.82187C16.1609 6.38575 14.1861 4.41089 11.7499 4.41089H9.03549Z",
    fill: "#CAD6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96382 8.82187C4.96382 6.57315 6.78677 4.7502 9.03549 4.7502V4.07158C6.41198 4.07158 4.28521 6.19836 4.28521 8.82187H4.96382ZM4.96382 11.5363V8.82187H4.28521V11.5363H4.96382ZM9.03549 15.608C6.78677 15.608 4.96382 13.785 4.96382 11.5363H4.28521C4.28521 14.1598 6.41198 16.2866 9.03549 16.2866V15.608ZM11.7499 15.608H9.03549V16.2866H11.7499V15.608ZM15.8216 11.5363C15.8216 13.785 13.9987 15.608 11.7499 15.608V16.2866C14.3735 16.2866 16.5002 14.1598 16.5002 11.5363H15.8216ZM15.8216 8.82187V11.5363H16.5002V8.82187H15.8216ZM11.7499 4.7502C13.9987 4.7502 15.8216 6.57315 15.8216 8.82187H16.5002C16.5002 6.19836 14.3735 4.07158 11.7499 4.07158V4.7502ZM9.03549 4.7502H11.7499V4.07158H9.03549V4.7502Z",
    fill: "url(#paint2_linear_5443_3676)",
    fillOpacity: 0.7,
    mask: "url(#path-6-inside-3_5443_3676)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_5443_3676",
    x: 14.1965,
    y: 13.9832,
    width: 19.5364,
    height: 19.5364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5443_3676"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5443_3676",
    result: "effect2_dropShadow_5443_3676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5443_3676",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_5443_3676"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdi_5443_3676",
    x: 0.624512,
    y: 13.9832,
    width: 19.5364,
    height: 19.5364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5443_3676"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5443_3676",
    result: "effect2_dropShadow_5443_3676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5443_3676",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_5443_3676"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdi_5443_3676",
    x: 0.624512,
    y: 0.410889,
    width: 19.5364,
    height: 19.5364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5443_3676"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5443_3676",
    result: "effect2_dropShadow_5443_3676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5443_3676",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_5443_3676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5443_3676",
    x1: 18.4849,
    y1: 19.7136,
    x2: 28.5793,
    y2: 28.3659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5443_3676",
    x1: 4.91292,
    y1: 19.7136,
    x2: 15.0073,
    y2: 28.3659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5443_3676",
    x1: 4.91292,
    y1: 6.14135,
    x2: 15.0073,
    y2: 14.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActiveDark);
export default __webpack_public_path__ + "static/media/dashboard-active-dark.0ccdd2b71bf8c22119e4ed4d56a8dddd.svg";
export { ForwardRef as ReactComponent };